import { v4 as uuidV4 } from 'uuid';

import {
  type FilterLegacy,
  SimpleEventTypeLegacy,
  UniquenessFilterTypesEnumLegacy,
} from '@verantos-dev/types-cohorts';
import { Simple_eventContext } from '@verantos-dev/util-cohort-builder-typescript-runtime';

import getActualValueFromDSL from './getActualValueFromDSL';

const getConditionOccurrenceEvents = (
  event: Simple_eventContext,
  dirty?: boolean // set to true to annotate input fields as dirty
) => {
  const eventFilters = event
    .condition_occurrence_event()
    ?.condition_occurrence_event_definition()
    ?.condition_occurrence_event_criteria()
    ?.condition_occurrence_event_filter();
  const conceptFilters: FilterLegacy[] = [];
  const uniquenessFilters: FilterLegacy[] = [];
  const relatedEntityFilters: FilterLegacy[] = [];

  eventFilters &&
    eventFilters.forEach((conceptFilter) => {
      const conceptGroupFilter = conceptFilter
        ?.condition_occurrence_concept_filters()
        ?.condition_occurrence_concept_group_filter();

      const uniquenessGroupFilter = conceptFilter
        ?.condition_occurrence_uniqueness_filters()
        ?.condition_occurrence_uniqueness_filter();

      const relatedEntityFilter = conceptFilter
        ?.condition_occurrence_related_entity_filters()
        ?.condition_occurrence_related_entity_filter();

      const relatedEntityVisitOccurrenceSubFilter =
        relatedEntityFilter?.visit_occurrence_sub_filter();
      const relatedEntityProcedureOccurrenceSubFilter = relatedEntityFilter?.provider_sub_filter();

      if (conceptGroupFilter) {
        conceptFilters.push({
          id: uuidV4(),
          inputFields: conceptGroupFilter
            ? [
                {
                  id: uuidV4(),
                  value: conceptGroupFilter.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE().getText(),
                  dirty,
                },
                {
                  id: uuidV4(),
                  value: conceptGroupFilter.IN().getText(),
                  dirty,
                },

                {
                  id: uuidV4(),
                  value:
                    conceptGroupFilter?.concept_group_selection().CONCEPT_GROUP().toString() || '',
                  dirty,
                },
              ]
            : [],
        });
      }
      if (uniquenessGroupFilter) {
        // at one time only one of the following will be present
        const simpleUniquenessFilter = uniquenessGroupFilter?.simple_uniqueness_filter();
        const simpleUniquenessFilterFixedWindow = uniquenessGroupFilter
          ?.simple_uniqueness_filter_window()
          ?.fixed_window_uniqueness_filter();
        const simpleUniquenessFilterRollingWindow = uniquenessGroupFilter
          ?.simple_uniqueness_filter_window()
          ?.rolling_window_uniqueness_filter();

        const filter =
          simpleUniquenessFilter ||
          simpleUniquenessFilterFixedWindow ||
          simpleUniquenessFilterRollingWindow;

        // finding the filter type
        let filterType = '';
        if (simpleUniquenessFilter) {
          filterType = UniquenessFilterTypesEnumLegacy.FIXED_WINDOW;
        } else if (simpleUniquenessFilterFixedWindow) {
          filterType = simpleUniquenessFilterFixedWindow?.FIXED_WINDOW()?.getText() || '';
        } else if (simpleUniquenessFilterRollingWindow) {
          filterType = simpleUniquenessFilterRollingWindow?.ROLLING_WINDOW()?.getText() || '';
        } else {
          filterType = '';
        }

        uniquenessFilters.push({
          id: uuidV4(),
          inputFields: uniquenessGroupFilter
            ? [
                {
                  id: uuidV4(),
                  value: filterType,
                  dirty,
                },
                {
                  id: uuidV4(),
                  value: filter?.simple_event_int()?.getText() || '',
                  dirty,
                },
                {
                  id: uuidV4(),
                  value: filter?.TIME_UNIT()?.getText() || '',
                  dirty,
                },
                {
                  id: uuidV4(),
                  value:
                    uniquenessGroupFilter?.CONDITION_OCCURRENCE_DATE_ATTRIBUTE()?.getText() || '',
                  dirty,
                },
              ]
            : [],
        });
      }
      if (relatedEntityVisitOccurrenceSubFilter) {
        relatedEntityFilters.push({
          id: uuidV4(),
          inputFields: relatedEntityFilter
            ? [
                {
                  id: uuidV4(),
                  value: relatedEntityVisitOccurrenceSubFilter?.VISIT_OCCURRENCE()?.getText() || '',
                  dirty,
                },
                {
                  id: uuidV4(),
                  value:
                    relatedEntityVisitOccurrenceSubFilter
                      ?.visit_occurrence_concept_group_filter()
                      ?.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE()
                      .getText() || '',
                  dirty,
                },
                {
                  id: uuidV4(),
                  value:
                    relatedEntityVisitOccurrenceSubFilter
                      ?.visit_occurrence_concept_group_filter()
                      ?.IN()
                      ?.getText() || '',
                  dirty,
                },
                {
                  id: uuidV4(),
                  value:
                    relatedEntityVisitOccurrenceSubFilter
                      ?.visit_occurrence_concept_group_filter()
                      ?.concept_group_selection()
                      .CONCEPT_GROUP()
                      .toString() || '',
                  dirty,
                },
              ]
            : [],
        });
      }
      if (relatedEntityProcedureOccurrenceSubFilter) {
        relatedEntityFilters.push({
          id: uuidV4(),
          inputFields: relatedEntityFilter
            ? [
                {
                  id: uuidV4(),
                  value: relatedEntityProcedureOccurrenceSubFilter?.PROVIDER()?.getText() || '',
                  dirty,
                },
                {
                  id: uuidV4(),
                  value:
                    relatedEntityProcedureOccurrenceSubFilter
                      ?.provider_concept_group_filter()
                      ?.PROVIDER_CONCEPT_ATTRIBUTE()
                      .getText() || '',
                  dirty,
                },
                {
                  id: uuidV4(),
                  value:
                    relatedEntityProcedureOccurrenceSubFilter
                      ?.provider_concept_group_filter()
                      ?.IN()
                      ?.getText() || '',
                  dirty,
                },
                {
                  id: uuidV4(),
                  value:
                    relatedEntityProcedureOccurrenceSubFilter
                      ?.provider_concept_group_filter()
                      ?.concept_group_selection()
                      .CONCEPT_GROUP()
                      .toString() || '',
                  dirty,
                },
              ]
            : [],
        });
      }
    });

  return {
    id: uuidV4(),
    name: getActualValueFromDSL(
      event.condition_occurrence_event()?.CONDITION_OCCURRENCE_ALIAS().getText()
    ),
    type: SimpleEventTypeLegacy.CONDITION_OCCURRENCE,
    conceptFilters,
    numericFilters: [],
    relatedEntityFilters,
    uniquenessFilters,
  };
};

export default getConditionOccurrenceEvents;
